// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style-module_warningIcon__12kyGSZmVHM-V0IuWFH4CZ"};